"use client";

import React, { useEffect, useState } from "react";
type SectionLanguage = "en" | "it";
export default function EventRegistrationPortal() {
  const [language, setLanguage] = useState<SectionLanguage>("en");
  useEffect(() => {
    const savedLanguage = localStorage.getItem("site-language");
    if (savedLanguage === "en" || savedLanguage === "it") {
      setLanguage(savedLanguage);
    }
  }, []);
  useEffect(() => {
    const handleStorageChange = () => {
      const savedLanguage = localStorage.getItem("site-language");
      if (savedLanguage === "en" || savedLanguage === "it") {
        setLanguage(savedLanguage);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);
  const t = {
    en: {
      title: "RSVP",
      instructions: "Please select your preferred language and complete your response below.",
      loadNote: "The RSVP form below may take a few moments to load — thank you for your patience.",
      deadline: "Kindly respond by July 20, 2026"
    },
    it: {
      title: "RSVP",
      instructions: "Seleziona la lingua desiderata e completa la tua risposta qui sotto.",
      loadNote: "Il modulo RSVP qui sotto potrebbe richiedere qualche istante per caricarsi — grazie per la pazienza.",
      deadline: "Si prega di rispondere entro il 20 luglio 2026"
    }
  }[language];
  return <section id="rsvp-form" className="bg-background text-foreground py-20 md:py-28 relative">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header + Instructions */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-4xl md:text-6xl font-serif tracking-tight mb-6">
            {t.title}
          </h2>

          <p className="text-base md:text-lg text-muted-foreground max-w-xl mx-auto mb-4">
            {t.instructions}
          </p>

          {/* NEW LOAD MESSAGE */}
          <p className="text-sm md:text-base text-muted-foreground italic max-w-xl mx-auto mb-6">
            {t.loadNote}
          </p>

          <div className="border-t border-primary/20 pt-6 mt-6">
            <p className="text-sm text-muted-foreground uppercase tracking-widest">
              {t.deadline}
            </p>
          </div>
        </div>

        {/* RSVP iframe */}
        <div className="bg-card/30 backdrop-blur-sm border border-primary/10 shadow-xl p-3 md:p-8">
          <iframe src="https://saraandmichael2026.rsvpify.com" style={{
          width: "100%",
          height: "900px",
          border: "none"
        }} title="Wedding RSVP" />
        </div>
      </div>
    </section>;
}